import { restHeartClient } from '..'

/**
 *
 * @param db
 * @param collection
 * @param id
 * @param data
 */
export function updateDocumentById(db: string, collection: string, id: string, data: object) {
	return restHeartClient.patch(`${db}/${collection}/${id}`, data)
}
